import React, { memo, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { Typography } from '@material-ui/core';
import { Error } from '@material-ui/icons';
import PropTypes from 'prop-types';

import { Truck } from '..';

import * as S from './styles';

function Card({ data, idposto, modalRef }) {
  // Open new windows window with defined sizes
  const token = useSelector((state) => state.auth);
  const handleOpenNewWindowDescarga = useCallback((value) => {
    console.log('ao abrir');
    console.log(value.preset);
    console.log(value.idposto);
    localStorage.setItem('preset', value.preset);
    localStorage.setItem('idposto', value.idposto);
    localStorage.setItem('Current-Route', window.location.pathname);
    localStorage.setItem('Authorization', 'Bearer ' + `${token.token}`);
    window.open(
      '/sinotico-descarregamento',
      'winname',
      'toolbar=0,location=0,menubar=0,status=0,width=580,height=700'
    );
  }, []);

  const filterPresetTipo = (index) => {
    if (data.tipoPreset === 2) {
      return true;
    }
    if (data.tipoPreset === 1 && index === 0) {
      return true;
    }
    return false;
  };

  return (
    <S.Wrapper>
      <S.WrapperHeader
        mod={data.modoOperacao.toLowerCase()}
        connected={data.conectado.toLowerCase() === 'c'}
      >
        <Typography
          style={{ cursor: 'pointer' }}
          onClick={() =>
            modalRef.current.handleOpenModal({ id: data?.idPreset })
          }
        >
          {data.nomePreset}
        </Typography>
      </S.WrapperHeader>
      {/* TCD */}
      {data.listaDescargas &&
        data.listaDescargas
          // .filter((item, index) => filterPresetTipo(index))
          .map((item, index) => (
            <S.WrapperTruck
              key={Math.random().toString()}
              onClick={() =>
                handleOpenNewWindowDescarga({
                  preset: data.idPreset,
                  idposto,
                  descarregamento: index,
                })
              }
            >
              <Truck data={item} ground={data?.aterramento === 1 ? 'A' : '0'} />
              <S.WrapperInput
                error={!!item.alarme}
                side={item.ladoBraco.toUpperCase()}
              >
                <Error />
                <input
                  name={Math.random().toString()}
                  value={item.alarme}
                  disabled
                />
              </S.WrapperInput>
            </S.WrapperTruck>
          ))}
    </S.Wrapper>
  );
}

Card.propTypes = {
  data: PropTypes.objectOf({
    idPreset: PropTypes.string.isRequired,
    modoOperacao: PropTypes.string.isRequired,
    listaCarregamentos: PropTypes.arrayOf(PropTypes.any).isRequired,
  }).isRequired,
  idposto: PropTypes.string.isRequired,
  modalRef: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default memo(Card);
